module.exports = __webpack_public_path__ + "Flag-470.f40d4ab35b79bfac6607de9cc4cf5eaa.svg";